export class TipoDocumento {
  idTipodocumento: number = null;
  dsTipodocumento: string = null;
  /*
		snCertificado: string = null;
		fkTipomateria: number = null;
		fkTipo: number = null;*/

  constructor(d?) {
    if (d) {
      this.idTipodocumento = d.idTipodocumento ? d.idTipodocumento : null;
      this.dsTipodocumento = d.dsTipodocumento ? d.dsTipodocumento : null;
    }
    /*
 this.snCertificado = d.snCertificado ? d.snCertificado : null;
 this.fkTipomateria = d.fkTipomateria ? new TipoMateria (d.fkTipomateria) : null;
 this.fkTipo = d.fkTipo ? new Tipo (d.fkTipo) : null;*/
  }
}
